var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid-cols-1 md:grid-cols-[5fr_2fr_5fr] pb-14 items-center"},[_c('div',[_c('QuickOffer',{on:{"requestTender":function($event){return _vm.$emit('requestTender', $event)}}})],1),_c('div',{staticClass:"orSticker"},[_c('p',[_vm._v(_vm._s(_vm.$t("landing.or")))])]),_c('div',[_c('SearchBox')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }